import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { UiLoader, UiTitle } from 'znanie-uikit';

import initializeApollo, { addApolloState } from 'apollo-client';

import LayoutConfines from 'components/layout/LayoutConfines';
import PageMeta from 'components/layout/PageMeta';

import PostsList from 'components/post/PostsList';

import { getPostsSsr, usePosts } from 'hooks/post/usePosts';

import { getMetaInfo } from 'utils/helpers';

import css from './news.module.scss';

const POSTS_LIMIT = 9;
const postsQueryParams = {
  offset: 0,
  limit: POSTS_LIMIT,
  published: true,
};

export default function News() {
  const { pathname } = useRouter();
  const {
    loading,
    data,
    fetchMore: fetchMorePosts,
  } = usePosts(postsQueryParams);

  const posts = data?.posts;

  const loadMorePosts = async () => {
    if (fetchMorePosts && posts) {
      await fetchMorePosts({
        variables: {
          offset: posts.length || 0,
          limit: POSTS_LIMIT,
          published: true,
        },
      });
    }
  };

  return (
    <>
      <PageMeta {...getMetaInfo(pathname)} />
      <LayoutConfines>
        <UiTitle className={css.title} size="big" as="h1">
          Новости
        </UiTitle>
        <UiLoader loading={loading}>
          <PostsList posts={data?.posts || []} onLoadMore={loadMorePosts} />
        </UiLoader>
      </LayoutConfines>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async () => {
  const apolloClient = initializeApollo();

  await getPostsSsr(apolloClient, postsQueryParams);

  return addApolloState(apolloClient, {
    props: {},
  });
};
